import React from 'react';
import { propTypes } from 'react-bootstrap/esm/Image';
import { Link } from 'react-router-dom';
import { useEffect , useState} from 'react';

const Itemcours = (props) => {
  console.log(props.read)
  const [reading, setReading] = useState(true)
  
  useEffect(() => {
    props.read.map((isRead)=>{
      if(!isRead) {
        setReading(false)
      }

    })
  }, [props.read])


    return (
        <div className="item-course">
            <div className="title-detail">
                <h4>{props.title}</h4>
                <span>
                    {props.score}
                    <i className="icon-black-star-silhouette"></i>
                </span>
            </div>
            <div className="btns">
                <button
                    className={`${props.has_tutorial ? 'active' : ''}`} type="button"
                    onClick={(e) => props.has_tutorial ? props.handleTutorial() : e.preventDefault()} >
                    {props.has_tutorial ? '✓ ' : ''}
                    آموزش
                    </button>
                    <button
                      className={`${reading  && props.has_exam ? 'active' : ''}`}
                      type="button"
                      onClick={(e) => reading  && props.has_exam? props.handleExam() : e.preventDefault()} >
                      {props.has_exam ? '✓ ' : ''}
                      آزمون
                    </button>
            </div>
        </div>
    );
}

export default Itemcours;